"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DEFAULT_SHORT_CODE_CHARACTERS: function() {
        return DEFAULT_SHORT_CODE_CHARACTERS;
    },
    DEFAULT_SHORT_CODE_LENGTH: function() {
        return DEFAULT_SHORT_CODE_LENGTH;
    },
    generateShortCode: function() {
        return generateShortCode;
    },
    generateShortCodeWithCheck: function() {
        return generateShortCodeWithCheck;
    }
});
const _async = require("nanoid/async");
const _promises = require("./promises");
const DEFAULT_SHORT_CODE_CHARACTERS = '23456789BCDFGHJKLMNPQRSTVWXYZ';
const DEFAULT_SHORT_CODE_LENGTH = 8;
function generateShortCode(length = DEFAULT_SHORT_CODE_LENGTH, characters = DEFAULT_SHORT_CODE_CHARACTERS) {
    return (0, _async.customAlphabet)(characters)(length);
}
async function generateShortCodeWithCheck(check, maxIterations = 10, length = DEFAULT_SHORT_CODE_LENGTH, characters = DEFAULT_SHORT_CODE_CHARACTERS) {
    let exists = true;
    let code = '';
    let count = 0;
    while(exists){
        if (count > maxIterations) {
            throw new Error(`Could not generate unique short code after ${maxIterations} attempts`);
        }
        code = await generateShortCode(length, characters);
        exists = await (0, _promises.asPromise)(check(code));
        count++;
    }
    return code;
}

//# sourceMappingURL=short-code.js.map